import React, {useState} from 'react';
import styles from './details-sidebar.module.scss';
import ShareButton from "@/components/global/share-button";

type Props = {
  studio: IStudioDetails | null | undefined
};

const StudioDetailsSidebar: React.FC<Props> = ({ studio }) => {
  const [showContactInfo, setShowContactInfo] = useState<boolean>(false);

  return (
    <div className={styles.studioDetailsSidebar}>
      <div className={styles.detailSection}>
        <div className={styles.imageContainer}>
          {studio ? (
              <img src={studio.image || '//placehold.it/400x400'} alt={studio.title || 'Loading...'} />
          ) : (
              <div className={styles.loadingImage} />
          )}
        </div>
        <div className={styles.title}>
          <h3>{studio?.title || 'در حال بارگزاری...'}</h3>
          <div className={styles.buttonContainer}>
            <ShareButton />
          </div>
        </div>
      </div>
      <div className={styles.detailSection}>
        <h5>اطلاعات کلی</h5>
        <div className={styles.infoContainer}>
          <div className={styles.infoItem}>
            <strong>شهر</strong>
            <span>
              {studio?.city}
            </span>
          </div>
          <div className={styles.infoItem}>
            <strong>تاریخ انتشار</strong>
            <span>
              {studio?.date}
            </span>
          </div>
        </div>
      </div>
      <div className={styles.showContactInfo}>
        <div className={styles.buttonContainer}>
          <button className={"btn btn-primary"} disabled={showContactInfo} type="button" onClick={() => setShowContactInfo(true)}>
            <i className="fa fa-phone" /> اطلاعات تماس
          </button>
        </div>
        <div className={styles.infoContainer}>
          {showContactInfo ? (
              <div className={styles.infoItem}>
                <span>شماره تماس</span>
                <a href={"tel:" + studio?.phone_number}>{studio?.phone_number}</a>
              </div>
          ) : ''}
        </div>
      </div>
    </div>
  );
}

export default StudioDetailsSidebar;
